export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@\$%\_\-\+\.,\^])[A-Za-z\d!@\$%\_\-\+\.,\^]{8,20}$/;

export const passwordRegexWithoutLength = /^[A-Za-z0-9!@\$%\_\-\+\.,\^]+$/;


export const nameRegex = /^[a-zA-Z0-9 ]{1,100}$/;

export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
